import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue'
import { EnumButtonSizes } from '@/enums/enums'

import ModalConfirmationDialog from '@/views/modals/ModalConfirmationDialog.vue'

import { useInstitutionalStore } from '@/stores/institutionalStore'
import { usePagesUtilStore } from '@/stores/pagesUtilStore'
import { useAuthStore } from '@/stores/authStore'

import messages from '@/utils/messages'
import { CONST_INSTITUTIONAL_STATUS } from '@/static/constantsInstitutional'


export default /*@__PURE__*/_defineComponent({
  __name: 'BtnCancelFocusedInstitutional',
  setup(__props) {

const institutionalStore = useInstitutionalStore()
const pagesUtilStore = usePagesUtilStore()
const authStore = useAuthStore()

/**
 * ✅ REGRA DE EXIBIÇÃO DO BOTÃO CANCELAR
 */
const showCancelButton = computed(() => {
  const status = institutionalStore.institutionalDetail?.status

  return (
    authStore.currentUserCanCancelInstitutional &&
    !!status &&
    [
      CONST_INSTITUTIONAL_STATUS.ADJUSTMENT_REQUESTED,
      CONST_INSTITUTIONAL_STATUS.ON_EDITING.id,
      CONST_INSTITUTIONAL_STATUS.APPROVED.id,
      CONST_INSTITUTIONAL_STATUS.PENDING_PUBLICATION.id,
      CONST_INSTITUTIONAL_STATUS.ACTIVE_INSTITUTIONAL.id,
      CONST_INSTITUTIONAL_STATUS.PUBLISHED.id
    ].includes(status)
  )
})

/**
 * Abre modal de confirmação
 */
const openDialog = () => {
  pagesUtilStore.showModalConfirmationCancelInstitutional = true // ✅
}


/**
 * Confirma cancelamento
 */
const onCancelFocusedInstitutionalBtnClick = async () => {
  try {
    pagesUtilStore.showLoading = true

    const id = institutionalStore.institutionalDetail?.id

    if (!id) return

    await institutionalStore.cancelInstitutional(id)

    messages.showSuccessMsg('Cadastro cancelado com sucesso!')

  } catch (error) {
    console.error(error)
    messages.showErrorMsg('Erro ao cancelar o cadastro.')
  } finally {
    pagesUtilStore.showLoading = false
  }
}

return (_ctx: any,_cache: any) => {
  const _component_c_q_btn = _resolveComponent("c-q-btn")!

  return (_openBlock(), _createElementBlock("div", null, [
    (showCancelButton.value)
      ? (_openBlock(), _createBlock(_component_c_q_btn, {
          key: 0,
          id: "btn-cancel-focused-institutional",
          propBtnLabel: "Cancelar",
          propBtnFunction: openDialog,
          propBtnTransparent: true,
          propBtnSize: _unref(EnumButtonSizes).LARGE_1
        }, null, 8, ["propBtnSize"]))
      : _createCommentVNode("", true),
    _createVNode(ModalConfirmationDialog, {
      propDialogTitle: "Atenção!",
      propConfirmationMsg: "Tem certeza de que deseja cancelar o cadastro?",
      propDialogType: "cancelar-institucional",
      onConfirm: onCancelFocusedInstitutionalBtnClick
    })
  ]))
}
}

})